export function resolveOemRoute(path: string) {
  const parts = path.split('/').filter(Boolean);
  const projectIndex = parts.indexOf('projects');
  const pageIndex = projectIndex >= 0 ? projectIndex + 2 : 1;
  return {
    projectId: projectIndex >= 0 ? parts[projectIndex + 1] : undefined,
    page: parts[pageIndex] === 'feasibility' ? 'feasibilities' : (parts[pageIndex] ?? 'home'),
    recordId: parts[pageIndex + 1],
  };
}
